/**
 * ACCOUNTS.md §3 — 密码 ≥10 位，不得包含用户名。
 * Pure so both the register/invite/reset forms and the tests use one rule set.
 */

export const MIN_PASSWORD_LENGTH = 10;

const COMMON = ["password", "123456", "qwerty", "111111", "abc123", "passw0rd", "iloveyou"];

/** Blocking problems — an empty list means the password may be submitted. */
export function passwordIssues(password: string, username = ""): string[] {
  const issues: string[] = [];
  if (password.length < MIN_PASSWORD_LENGTH) {
    issues.push(`至少 ${MIN_PASSWORD_LENGTH} 位，现在是 ${password.length} 位。`);
  }
  const u = username.trim().toLowerCase();
  if (u.length >= 3 && password.toLowerCase().includes(u)) {
    issues.push("不要把用户名放进密码里。");
  }
  const lower = password.toLowerCase();
  if (COMMON.some((c) => lower.includes(c))) {
    issues.push("这个密码太常见了，换一个别人猜不到的。");
  }
  return issues;
}

export type PasswordStrength = "weak" | "fair" | "strong";

export interface PasswordHint {
  strength: PasswordStrength;
  label: string;
  advice: string;
}

/** Non-blocking encouragement shown under the field. */
export function passwordHint(password: string, username = ""): PasswordHint {
  if (passwordIssues(password, username).length > 0) {
    return { strength: "weak", label: "还不够", advice: "先满足上面的要求。" };
  }
  const classes =
    Number(/[a-z]/.test(password)) +
    Number(/[A-Z]/.test(password)) +
    Number(/[0-9]/.test(password)) +
    Number(/[^A-Za-z0-9]/.test(password));
  if (password.length >= 16 || classes >= 3) {
    return { strength: "strong", label: "很好", advice: "这个密码足够结实了。" };
  }
  return {
    strength: "fair",
    label: "还可以",
    advice: "再长一点，或者加上数字和符号会更安全。",
  };
}

/** Shared check for the confirm field. */
export function confirmIssue(password: string, confirm: string): string | null {
  return confirm === password ? null : "两次输入的密码不一样。";
}
